<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter"><em>Illustrations</em></h1>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img1">The <em>St. Louis</em> departing Hamburg, May 13, 1939</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img2">Captain Gustav Schroeder</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img3">A picture postcard sold to the refugees</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img4">The social hall of the <em>St. Louis</em></a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img5">Front-page headline of the May 1939 issue of <em>Der Stuermer</em>, the Nazi propaganda sheet: “Jews Emigrate”</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img6">The refugees board the <em>St. Louis</em></a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img7">Lilly Joseph</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img8">Ten-year-old Liesl Joseph</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img9">June 18, 1939, the day after her eleventh birthday, Liesl Joseph was presented with a bouquet of two dozen roses by Morris Troper</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img10">Children who traveled alone on the <em>St. Louis:</em> seven-year-old Renatta Aber and her five-year-old sister Evelyne</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img11">The Spanier twins</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img12">The passenger committee</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch07.htm#img13">Otto Schiendick</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img14">Arrival in Havana</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img15">In Havana Harbor, friends and relatives shout up to the passengers on the <em>St. Louis</em></a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img16">Cuban guards stop the passengers from leaving the ship</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img17">Aboard the <em>St. Louis</em> in Havana Harbor</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img18">Cuban President Frederico Bru (left) and army chief Fulgencio Batista</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img19">Arrival in Antwerp</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img20">According to <em>Der Stuermer</em>, the “happy Jews” as they departed on the <em>St. Louis</em>, and on their return to Europe</a></p>
<p class="hanging"><a class="hlink" href="#/OEBPS/ch25.htm#img21">Captain Schroeder makes his last visit to the bombed-out hulk of the <em>St. Louis</em></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illustrations.vue?57ae4db6